import { Event, Interface, Method } from '@central-products/transport-bus-common';
import {
  CurrentState,
  GetSessionTokenRequest,
  GetSessionTokenResponse,
  LoginRequest,
  LoginState,
  TokenLoginRequest,
  GetSessionIdentifierResponse,
} from './interfaces';

export type OnStateChangedCallback = (payload: CurrentState) => void;

@Interface('common', 'session')
export class SessionManagerInterface {
  @Method('state.get')
  public getState(): Promise<CurrentState> {
    throw new Error('Method is not implemented yet');
  }

  @Event('state.changed')
  // @ts-ignore
  public onStateChanged(callback: OnStateChangedCallback): void {
    throw new Error('Event is not implemented yet');
  }

  @Method('token.get')
  // @ts-ignore
  public getSessionToken(data: GetSessionTokenRequest): Promise<GetSessionTokenResponse> {
    throw new Error('Method is not implemented yet');
  }

  @Method('sessionId.get')
  public getSessionIdentifier(): Promise<GetSessionIdentifierResponse> {
    throw new Error('Method is not implemented yet');
  }

  @Method('logIn')
  // @ts-ignore
  public logIn(data: LoginRequest): Promise<LoginState> {
    throw new Error('Method is not implemented yet');
  }

  @Method('logOut')
  public logOut(): Promise<LoginState> {
    throw new Error('Method is not implemented yet');
  }

  @Method('tokenLogIn')
  // @ts-ignore
  public tokenLogIn(data: TokenLoginRequest): Promise<LoginState> {
    throw new Error('Method is not implemented yet');
  }

  @Method('markActive')
  // @ts-ignore
  public markActive(): Promise<void> {
    throw new Error('Method is not implemented yet');
  }
}
